import React, {createContext, useReducer} from 'react'
import {RouteDetailReducer} from "../reducer/RouteDetailReducer";

export const RouteDetailContext = createContext()

const RouteDetailContextProvider = (props) => {
    // initialise picklistId from url parameter
    let initialPicklistId = '';
    if(props.params.picklistId && props.params.picklistId !== "NA"){
        initialPicklistId = decodeURIComponent(props.params.picklistId);
    }

    const state = {
        initialised: false,
        routeInfo: null,
        picklists: [],
        picklistContainers: {},
        selectedPicklist: initialPicklistId,
        containers: [],
        hazmatWeight: '...',
        bagCount: '...',
        ovCount: '...',
        isLoading: false,
        isAuthorizedUser: false,
        isTCPAuthorizationCheckEnabled: true,
        selectedPicklistTab: ''
    }
    const [ viewModelRD, dispatchRD ] = useReducer(RouteDetailReducer, state)
    return (
        <RouteDetailContext.Provider value = {{viewModelRD, dispatchRD}}>
            {props.children}
        </RouteDetailContext.Provider>
    )
}

export default RouteDetailContextProvider


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/context/RouteDetailContext.js